import { RelativeTimeTranslations, Unit } from '../types';

export const getOptions = (
  translations: RelativeTimeTranslations
): { label: string; value: Unit }[] => {
  const { days, months, years } = translations;
  return [
    {
      label: days,
      value: 'day',
    },
    {
      label: months,
      value: 'month',
    },
    {
      label: years,
      value: 'year',
    },
  ];
};
